import { StyleSheet } from '@react-pdf/renderer';
import {
  registerFontsForLanguage,
  getFontFamilyForLanguage,
} from 'utils/fonts';
import { getCurrentLocale } from 'utils/intl';

// Register fonts for the current language
const currentLanguage = getCurrentLocale();
registerFontsForLanguage(currentLanguage);

export const styles = StyleSheet.create({
  headerIWG: {
    fontSize: 12,
    textAlign: 'center',
    color: 'grey',
  },
  firstPage: {
    fontSize: 10,
    paddingTop: 30,
    paddingBottom: 30,
    paddingLeft: 60,
    paddingRight: 60,
    lineHeight: 1.5,
    flexDirection: 'column',
  },
  reportTitleContainer: {
    marginTop: 10,
  },
  reportTitleText: {
    fontFamily: getFontFamilyForLanguage(currentLanguage),
    fontWeight: 'bold',
    letterSpacing: 4,
    fontSize: 22,
    textAlign: 'center',
  },
  reportNoContainer: {
    flexDirection: 'row',
    marginTop: 12,
    justifyContent: 'flex-end',
  },
  reportNoLabel: {
    fontSize: 12,
    fontFamily: getFontFamilyForLanguage(currentLanguage),
    fontWeight: 'normal',
  },
  reportNoText: {
    fontSize: 30,
    fontFamily: getFontFamilyForLanguage(currentLanguage),
    fontWeight: 'normal',
  },
  reportDateContainer: {
    flexDirection: 'row',
    marginTop: 12,
    justifyContent: 'flex-end',
  },
  reportDateLabel: {
    fontSize: 12,
    fontFamily: getFontFamilyForLanguage(currentLanguage),
    fontWeight: 'normal',
  },
  reportDateText: {
    fontSize: 14,
    fontFamily: getFontFamilyForLanguage(currentLanguage),
  },
  reportInfoTable: {
    flexWrap: 'wrap',
    marginTop: 20,
    borderWidth: 1,
    minHeight: 110,
  },
  reportInfoRow: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 20,
    fontFamily: getFontFamilyForLanguage(currentLanguage),
  },
  reportInfoKey: {
    width: '20%',
    padding: 1,
    fontWeight: 'bold',
  },
  reportInfoValue: {
    width: '30%',
    padding: 1,
  },
  reportInfoValue2: {
    width: '80%',
    padding: 1,
  },
  reportSectionTitle: {
    flexDirection: 'row',
    marginTop: 5,
    padding: 5,
    fontWeight: 'bold',
    fontSize: 14,
    fontFamily: getFontFamilyForLanguage(currentLanguage),
  },
  reportSectionContent: {
    flexWrap: 'wrap',
    minHeight: '10%',
    marginTop: 2,
    padding: 1,
    borderWidth: 1,
    fontFamily: getFontFamilyForLanguage(currentLanguage),
    // borderColor: '#bff0fd',
  },
  reportDateAndDoctors: {
    flexDirection: 'row',
    marginTop: 5,
  },
  reportDate: {
    width: '50%',
    justifyContent: 'flex-end',
    fontFamily: getFontFamilyForLanguage(currentLanguage),
  },
  reportDoctors: {
    width: '50%',
    justifyContent: 'center',
    fontFamily: getFontFamilyForLanguage(currentLanguage),
  },

  keyImage: {
    margin: 5,
    width: '40%',
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
});
